import { globalActions, accountsActions, withdrawActions } from '@modules';
import { loginActions } from '@modules/login';
import { TMiddleware } from '@modules/types';

export const redirectErrors: TMiddleware = store => next => action => {
  const isLoginAction = [
    loginActions.login.rejected.type,
    loginActions.verifyPhone.rejected.type,
    loginActions.verifyPassword.rejected.type,
    loginActions.setEmail.rejected.type,
    loginActions.verifyEmail.rejected.type,
    loginActions.resetPasswordEmail.rejected.type,
    loginActions.resetPasswordPhone.rejected.type,
    loginActions.resetPasswordVerifyEmail.rejected.type,
    loginActions.resetPasswordVerifyPhone.rejected.type,
    loginActions.setPassword.rejected.type,
    loginActions.resendVerification.rejected.type,
    withdrawActions.withdrawResendVerification.rejected.type,
    accountsActions.accountWithdrawVerifyResend.rejected.type,
  ].includes(action.type);

  if (isLoginAction) {
    const message = 'Key is invalid.';
    if (action.payload.code === CONST.errorCodes.userBlocked) {
      store.dispatch(globalActions.redirectTo('accountBlocked'));
    }
    if (
      action.payload.code === CONST.errorCodes.keyIsInvalid &&
      action.payload.message === message
    ) {
      store.dispatch(globalActions.redirectTo('loginEmail'));
    }
  }
  return next(action);
};

export default redirectErrors;
